import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-landing-sidemenu',
    templateUrl: './landing-sidemenu.component.html',
    styleUrls: ['./landing-sidemenu.component.scss']
})
export class LandingSidemenuComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
